<template>
  <div class="source-card">
    <div class="source-card-label">
      Источник:
    </div>
    <div class="source-card-name">
      <v-img v-if="source.image" class="source-img mr-3" :src="source.image" />
      <div v-else class="source-abbreviation mr-3">
        <span>{{ source.abbreviation }}</span>
      </div>
      <div class="source-name">
        {{ source.name }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SourceCard',
    props: {
      source: {
        type: Object,
        default: () => {},
      },
    },
  }
</script>

<style scoped lang="less">
.source-card {

  &-label {
    margin-bottom: 14px;
    font-size: 20px;
    line-height: 21px;
  }

  &-name {
    display: inline-flex;
    align-items: center;
    //border-radius: 10px;
    //background-color: #f1f3f6;
    //padding: 10px 15px;
  }

  .source-name {
    font-size: 18px;
  }
  .source-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .source-abbreviation {
    width: 40px;
    height: 40px;
    font-size: 16px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: @color-btn-grey;
    color: #fff;
  }
}

</style>
